import React, { useState } from 'react';
import { useMovieContext } from '../context/MovieContext';
import './Play.css'; // Import the CSS file for styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const Play = () => {
  const { selectedMovieId, videos, error, handleSelectMovie } = useMovieContext();
  const [showVideo, setShowVideo] = useState(true);

  const handleClose = () => {
    setShowVideo(false);
    handleSelectMovie(null); // Deselect the movie
  };

  if (error) {
    return <div className="play-error">Error: {error}</div>;
  }

  return (
    <div className={`play-container ${showVideo ? 'show' : 'hide'}`}>
      {showVideo && videos.length > 0 && (
        <>
          <button className="close-btn" onClick={handleClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <iframe
            className="video-player"
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${videos[0].key}`}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        </>
      )}
    </div>
  );
};

export default Play;






























































































// // src/components/Play.js
// import React, { useState, useEffect } from 'react';
// import { useMovieContext } from '../context/MovieContext';

// const Play = () => {
//   const { selectedMovieId } = useMovieContext();
//   const [videos, setVideos] = useState([]);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!selectedMovieId) return; // Add a check for selectedMovieId being null

//     const options = {
//       method: 'GET',
//       headers: {
//         accept: 'application/json',
//         Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
//       }
//     };

//     fetch(`https://api.themoviedb.org/3/movie/${selectedMovieId}/videos?language=en-US`, options)
//       .then(response => {
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return response.json();
//       })
//       .then(data => {
//         setVideos(data.results);
//       })
//       .catch(error => {
//         console.error('There was a problem with your fetch operation:', error);
//         setError(error.message || 'An error occurred while fetching data');
//       });
//   }, [selectedMovieId]);

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   return (
//     <div>
//       {videos.length > 0 && (
//         <iframe
//           width="560"
//           height="315"
//           src={`https://www.youtube.com/embed/${videos[0].key}`}
//           frameBorder="0"
//           allow="autoplay; encrypted-media"
//           allowFullScreen
//         ></iframe>
//       )}
//     </div>
//   );
// };

// export default Play;














































































































































































































































































// // src/components/Play.js

// import React, { useState, useEffect } from 'react';

// const Play = ({ movieId }) => {
//   const [videos, setVideos] = useState([]);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const options = {
//       method: 'GET',
//       headers: {
//         accept: 'application/json',
//         Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
//       }
//     };

//     fetch(`https://api.themoviedb.org/3/movie/${movieId}/videos?language=en-US`, options)
//       .then(response => {
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return response.json();
//       })
//       .then(data => {
//         setVideos(data.results);
//       })
//       .catch(error => {
//         console.error('There was a problem with your fetch operation:', error);
//         setError(error.message || 'An error occurred while fetching data');
//       });
//   }, [movieId]);

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   return (
//     <div>
//       {videos.length > 0 && (
//         <iframe
//           width="560"
//           height="315"
//           src={`https://www.youtube.com/embed/${videos[0].key}`}
//           frameborder="0"
//           allow="autoplay; encrypted-media"
//           allowfullscreen
//         ></iframe>
//       )}
//     </div>
//   );
// };

// export default Play;

